<div class="container" data-cy="ops-settings-system-color-custom-color-modal">
    <div class="header">
        <h6 class="sub-title">
            {{ 'new-system-dialog.sub-title' | translate }}
        </h6>
        <h4 class="main-title">
            {{ 'new-system-dialog.main-title' | translate }}
        </h4>
    </div>
    <div class="content">
        <div class="input-container">
            <span class="input-title">{{ 'new-system-dialog.name.input-title' | translate }}</span>
            <app-channel-text-input
                [name]="COLOR_ASSIGNMENT"
                label="new-system-dialog.name.input-label"
                [value]="data?.name"
                (onInputChange)="onInputChange($event)"
                (onFocusChange)="onInputChange($event)"
                [inputError]="validationErrors?.name"
                [maxLength]="32">
            </app-channel-text-input>
        </div>
        <div class="input-container">
            <span class="input-title">{{ 'new-system-dialog.color.input-title' | translate }}</span>
            <app-system-color-input
                #systemColorInput
                [data]="data"
                [offOptions]="true"
                [createMode]="true"
                [canEditVessel]="true"
                (onColorChange)="handleColorChange($event)">
            </app-system-color-input>
        </div>
    </div>
</div>

<div class="buttons-container">
    <div class="cancel button" data-cy="ops-settings-system-color-custom-cancel-button" (click)="cancelClick()">
        {{ 'shipyard.create.dialog.form.button.cancel' | translate }}
    </div>
    <div
        class="create button"
        data-cy="ops-settings-system-color-custom-color-create-button"
        [class.disabled]="isConfirmDisabled()"
        (click)="createButtonClick()">
        {{ (data.mode ? 'new-system-dialog.edit.button' : 'new-system-dialog.create.button') | translate }}
    </div>
</div>
